import { defineComponent } from 'vue';
export default defineComponent({
    name: 'DropdownItemsWrapper',
    props: {
        header: { type: String, default: '' },
    },
    emits: ['close'],
    setup(_, { emit }) {
        const close = () => {
            emit('close');
        };
        return { close };
    },
});
